export default __webpack_public_path__ + "static/media/sch5_w640.6678b5b8.jpg";